import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  RightDrawerContainer,
  DownArrowDraw,
  DropDownSearchDraw
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  textarea,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DatePicker } from "antd";
import moment from "moment";
import { DatePickerY, GlobalSet } from "../../pageStyled";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getJumboReelDetails,
  editJumboReel,
} from "../../../Services/productionPlanningServices";
import {
  getProductDetails,
  getProductsData,
} from "../../../Services/productServices";
import { paperMachineListData } from "../../../Services/machineServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { getUnitData } from "../../../Services/measurementService";
import { lengthUnit, weightUnit } from "../../../Utils/Constant/MeasurementUnitList";

const { RangePicker } = DatePicker;

const dateFormat = "YYYY/MM/DD";

const customFormat = (value) => `custom format: ${value.format(dateFormat)}`;

const { Option } = Select;
const shiftData = ["1st", "2nd", "3rd"];

const { TextArea } = Input;

const EditJumboReel = (props) => {
  const [products, setProducts] = useState([]);
  const [productData, setProductData] = useState({
    bulk: "",
    gsm: "",
  });
  const [machines, setMachines] = useState([]);
  const [machine, setMachine] = useState();
  const [shift, setshift] = useState(shiftData[0]);
  const location = useLocation();
  const [id, setId] = useState(location.state.id);
  const [details, setDetails] = useState();
  const [date, setDate] = useState();
  const [form] = Form.useForm();
  const [showToaster, setShowToaster] = useState(false);
  const [hasMappedParentReel, setHasMappedParentReel] = useState();
  const [isProductDropdownOpen, setProductDropdown] = useState(false);
  const [measurementData, setMeasurementData] = useState();
  const [actionToaster, setActionToaster] = useState({
      error: "",
      msg: "",
  });
  const OnProductToggleSelect =()=>{
    setProductDropdown((prevState) => !prevState
  )
  }
  useEffect(() => {
    getJumboReelDetails(id)
      .then((resp) => {
        setDetails(resp.data.data);
        setDate(resp.data.data.product_date);
        const mappedBool =
          resp.data.data.mapped_parent_reels &&
          resp.data.data.mapped_parent_reels.length > 0
            ? true
            : false;
        setHasMappedParentReel(mappedBool);
      })
      .catch((err) =>
        console.log("Error which fetching jumbo reel details", err)
      );
  }, []);

  useEffect(() => {
    getProductsData()
      .then((response) => {
        setProducts(response);
      })
      .catch((error) => {
        console.log("Error in fetching products list:", error);
      });
  }, []);

  useEffect(() => {
    paperMachineListData()
      .then((response) => {
        const codes = response.map((machine) => {
          return machine.code;
        });
        setMachines(codes);
      })
      .catch((error) => {
        console.log("Error in fetching products list:", error);
      });
  }, []);

  useEffect(() => {
    getUnitData()
      .then((response) => {
        if(response && !response.error){
          setMeasurementData(response.data);
        }
      })
      .catch((error) => {
        console.log("Error in fetching advanced settings data:", error);
      });
  }, []);

  const handleShiftChange = (value) => {
    setshift(shiftData[value]);
  };
  const handleProduct = (e) => {
    getProductDetails(e)
      .then((response) => {
        setProductData({
          bulk: `${response.data.bulk}`,
          gsm: `${response.data.gsm}`,
        });
        form.setFieldsValue({ product_spec: response.data.product_spec });
      })
      .catch((error) => {
        console.log("Error in getting product specification list");
      });
  };
  const handleMachineChange = (value) => {
    setMachine(machines[value]);
  };

  const onFinish = async (values) => {
    const body = {
      number: values.number,
      product: values.product_name,
      production_date: moment(values.production_date).format("YYYY-MM-DD"),
      shift: values.shift,
      weight: values.weight,
      machine: values.machine,
      width: values.width,
      remarks: values.remarks,
      remarks: values.remarks,
      weight_utilized: 0,      
      units:{
        weight: values.weightUnit,
        weight_utilized: values.weightUnit,
        width: values.unit
      }
    };
    // console.log(body);
    editJumboReel(body)
      .then((resp) => {
        setActionToaster({
            error: false,
            msg: "Jumbo Roll is successfully saved",
          });
        setShowToaster(true);
        setTimeout(() => {
          setShowToaster(false);
          window.history.back();
        }, 2000);
      })
      .catch((err) => {
        console.log("Error while editing jumbo reel", err);
        if(err?.response?.status == 500){
          setActionToaster({
            error: true,
            msg: "Something went wrong. Please try again",
          });
        } else{
          setActionToaster({
            error: true,
            msg: err?.response?.data?.msg,
          });
        }
        setShowToaster(true);
        setTimeout(() => {
          setShowToaster(false);
        }, 2000);
      });
  };

  const dateHandler = (e) => {
    const testDate = new Date(e._d);
    setDate(moment(testDate).format("YYYY-MM-DD"));
  };

  return (products && machines && measurementData && details) ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          //onBack={() => window.history.back()}
          title={details.number}
          extra={[
            <Button
              key="3"
              className="textTypeBtn"
              onClick={() => window.history.back()}
            >
              Cancel changes
            </Button>,
            <Button
              key="2"
              disabled={hasMappedParentReel}
              className="themeBtn"
              onClick={() => {
                form.submit();
              }}
            >
              <Iconmoon icon="addcircle" size={14} color="#ffffff" />
              Save Jumbo Roll
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              name="basic"
              autoComplete="off"
              className="haberLogin"
              form={form}
              onFinish={onFinish}
            >
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>
                      The general details of the jumbo roll will be used in
                      reports and production details
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Jumbo Roll Number</label>
                        <p>Jumbo roll will be identified by this number</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="number"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          className=""
                          initialValue={details.number}
                        >
                          <Input
                            placeholder="Enter Jumbo Roll Number"
                            defaultValue="HW19092021" // Value is populated on the basis of selection of Product Name
                            disabled
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Product Specifications</h2>
                    <p>
                      The product specification will be used to define grade and
                      quality of the jumbo roll
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product Name</label>
                        <p>Unique name to identify the product</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="product_name"
                          rules={[{}]}
                          className=""
                          initialValue={details.product}
                        >
                          <Select
                            placeholder="Select product name"
                            suffixIcon={ isProductDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                            onBlur = {OnProductToggleSelect}
                            onFocus = {OnProductToggleSelect}
                            showSearch
                            optionFilterProp="children"
                            defaultValue={details.product}
                            onChange={handleProduct}
                          >
                            {products.map((product) => (
                              <Option key={product.code}>
                                {product.code} - {product.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product Specifications</label>
                        <p>Combination of Grade/GSM/BF/Quality/Moisture</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="product_spec"
                          rules={[{}]}
                          className=""
                          initialValue={details.product_spec}
                        >
                          <Input
                            placeholder="Product Specifications"
                            disabled
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Production Details</h2>
                    <p>
                      The production details specify when and where will this
                      jumbo roll be produced.
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Production Date</label>
                        <p>The production date of this jumbo roll</p>
                      </div>
                    </Col>

                    <Col span={12} className="blockBreak">
                      <div className="boxFormType">
                        <DatePickerY>
                          <Form.Item
                            name="production_date"
                            initialValue={moment(
                              details.production_date,
                              "YYYY-MM-DD"
                            )}
                          >
                            <DatePicker
                              format={"YYYY-MM-DD"}
                              onChange={dateHandler}
                            />
                          </Form.Item>
                        </DatePickerY>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Shift</label>
                        <p>Production shift for this jumbo roll </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item name="shift" initialValue={details.shift}>
                          <Select
                            placeholder="Select shift"
                            suffixIcon={<DownArrowDraw />}
                            onChange={handleShiftChange}
                          >
                            {shiftData.map((shift) => (
                              <Option key={shift}>{shift}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Weight</label>
                        <p>Weight of the jumbo roll</p>
                      </div>
                    </Col>
                    <Col span={12} className="d-flex">
                    <div
                        className="boxFormType"
                        style={{ marginBottom: "0", width: "90%", paddingRight:'5px' }}
                      >
                        <Form.Item
                          name="weight"
                          rules={[
                            {
                              required: true,
                              message: "Mandatory field.",
                            },
                            {
                              pattern: new RegExp(/^\d+(\.\d+)?$/),
                              message: "Only Numeric & Decimal Input allowed",
                            },
                            {
                              max: 50,
                              message: "Max 50 characters allowed",
                            },
                          ]}
                          className=""
                          initialValue={(details.weight + details.weight_utilized).toString()}
                        >
                          <Input placeholder="Enter Weight" />
                        </Form.Item>
                      </div>
                      <div
                        className="boxFormType"
                        style={{ marginTop: "7px", width: "90%" }}
                      >
                        <Form.Item
                          name="weightUnit"
                          rules={[
                            {
                              required: true,
                              message: "This is a required field",
                            },
                          ]}
                          className=""
                          initialValue={details.units.weight}
                        >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                          >
                            {measurementData.units_management.weight.data.map((item) => (
                              <Option key={item} value={item}>
                                {weightUnit[item]?.displayName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Machine</label>
                        <p>
                          The Jumbo roll with be produced on selected machine
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="machine"
                          initialValue={details.machine}
                        >
                          <Select
                            placeholder="Select machine"
                            suffixIcon={<DownArrowDraw />}
                            defaultValue={details.machine}
                            onChange={handleMachineChange}
                            showSearch
                            optionFilterProp="children"
                          >
                            {machines.map((machine) => (
                              <Option key={machine}>{machine}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Width</label>
                        <p>Width of the jumbo roll</p>
                      </div>
                    </Col>
                    <Col span={12} className="d-flex twoFields">
                      <div className="boxFormType" style={{ marginBottom: "0", width: "90%", paddingRight:'5px' }}>
                        <Form.Item
                          name="width"
                          rules={[
                            {
                              required: true,
                              message: "Mandatory field.",
                            },
                            {
                              pattern: new RegExp(/^\d+(\.\d+)?$/),
                              message: "Only Numeric & Decimal Input allowed",
                            },
                            {
                              max: 10,
                              message: "Max 10 digits allowed",
                            },
                          ]}
                          className=""
                          initialValue={details.width.toString()}
                        >
                          <Input placeholder="Enter Width" />
                        </Form.Item>
                        {/* <span className="nonEditable">CM</span> */}
                      </div>
                      <div
                        className="boxFormType"
                        style={{ marginTop: "7px", width: "90%" }}
                      >
                        <Form.Item
                          name="unit"
                          rules={[
                            {
                              required: true,
                              message: "This is a required field",
                            },
                          ]}
                          initialValue={details.units.width}
                          className="dBlock"
                        >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                          >
                            {measurementData.units_management.length.data.map((item) => (
                              <Option key={item} value={item}>
                              {lengthUnit[item]?.displayName}
                            </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Other Information</h2>
                    <p>All other information related to this jumbo roll</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Remarks <span>(Optional)</span>
                        </label>
                        <p>Extra information related to this jumbo roll</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Form.Item
                            name="remarks"
                            //rules={[{ required: true }]}
                            className=""
                            initialValue={details.remarks}
                          >
                            <TextArea
                              maxLength={100}
                              style={{ height: 90 }}
                              placeholder="Enter remarks"
                              initialValue={details.remarks}
                            />
                          </Form.Item>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      {showToaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setShowToaster}
          color={`${actionToaster?.error ? "red" : "green"} toaster`}
          icon={actionToaster?.error ? alertRed : alertGreen}
          msg={actionToaster?.msg}
        >
          {setTimeout(() => setShowToaster(false), 3000)}
        </AlertContainer>
      )}
    </RightLayoutContainer>
  ) : (
    <></>
  );
};

export default EditJumboReel;
